// 身份证号校验工具
// 实现 GB 11643-1999 标准的 18 位身份证号校验、出生日期解析与成年判断。

// 加权因子表
const WEIGHTS = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
// 校验位映射表，索引为前 17 位加权和 mod 11
const CHECK_CODES = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

// 基础正则：17 位数字 + 1 位数字或 X/x
const ID_CARD_REGEX = /^\d{17}[\dXx]$/;

// 校验 18 位身份证号格式和校验位是否合法
export const isValidIdCard = (idCard) => {
  const value = String(idCard || '').trim();
  if (!ID_CARD_REGEX.test(value)) return false;

  // 计算校验位
  let sum = 0;
  for (let i = 0; i < 17; i += 1) {
    sum += Number(value.charAt(i)) * WEIGHTS[i];
  }
  const expected = CHECK_CODES[sum % 11];
  const actual = value.charAt(17).toUpperCase();
  if (expected !== actual) return false;

  // 校验生日是否真实存在
  const birth = parseBirthDate(value);
  return birth !== null;
};

// 从身份证号中解析出生日期（YYYYMMDD 位于第 7-14 位）
// 返回 Date 对象；若无法解析或不是合法日期则返回 null
export const parseBirthDate = (idCard) => {
  const value = String(idCard || '').trim();
  if (value.length < 14) return null;

  const year = Number(value.substring(6, 10));
  const month = Number(value.substring(10, 12));
  const day = Number(value.substring(12, 14));
  if (!year || !month || !day) return null;

  // 用 UTC 构造再回读，规避时区造成的偏差；同时验证日期是否被静默修正
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }
  return date;
};

// 是否成年（周岁 ≥ 18），以今天为基准
export const isAdult = (idCard) => {
  const birth = parseBirthDate(idCard);
  if (!birth) return false;

  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  // 未到生日则减一年
  const monthDiff = today.getMonth() - birth.getMonth();
  const dayDiff = today.getDate() - birth.getDate();
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age -= 1;
  }
  return age >= 18;
};
